import { render, staticRenderFns } from "./VVideoIndex.vue?vue&type=template&id=1aa6a19c&scoped=true&"
import script from "./VVideoIndex.vue?vue&type=script&lang=js&"
export * from "./VVideoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6a19c",
  null
  
)

export default component.exports